import { render, staticRenderFns } from "./roleTemplateView.vue?vue&type=template&id=79db254c&scoped=true&"
import script from "./roleTemplateView.vue?vue&type=script&lang=js&"
export * from "./roleTemplateView.vue?vue&type=script&lang=js&"
import style0 from "./roleTemplateView.vue?vue&type=style&index=0&id=79db254c&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "79db254c",
  null
  
)

export default component.exports